<template>
  <div style="position:absolute; top:7px;right:15px;">
    <div  @click="toggleConditionalSection()">
      <img src="@/assets/img/icons/fold-icon.png" class="icon" alt="icon-fold" />
    </div>
    <div @click="toggleConditionalSection()">
      <img src="@/assets/img/icons/fold-icon.png" style="transform: rotate(180deg);" class="icon" alt="icon-fold" />
    </div>
  </div>
</template>

<script>
import EventBus from '@/eventBus'
export default {
  name: 'TreeFoldingButton',
  data () {
    return {
    }
  },
  methods: {
    toggleConditionalSection () {
      EventBus.$emit('toggleConditionalSectionParent')
    }
  }
}
</script>
<style scoped>
.icon {
  width: 15px;
  height: 15px;
  margin-top:2px;
  margin-left:10px;
  vertical-align: center;
  cursor:pointer;
}
</style>



// WEBPACK FOOTER //
// src/components/question/section/tree/TreeFoldingButton.vue